import React from 'react'
import { useRouter } from 'next/router'

import { HeaderBar, HeaderBarLeftAction } from '@wartek-id/header-bar'
import { historyUtils } from '@wartek-id/fe-toolbox'

import MateriText from 'app/PelatihanMandiriPage/pages/MateriText'
import { WithLayoutListener } from 'components/Layout/Desktop/DesktopLayout'

import CloseIcon from 'assets/icons/close.svg'

const MateriTextPage = (props) => {
  const { isDesktopScreenSize } = props

  return (
    <WithLayoutListener isDesktop={isDesktopScreenSize}>
      <MateriText isDesktop={isDesktopScreenSize} />
    </WithLayoutListener>
  )
}

const PageHeader = () => {
  const router = useRouter()

  return (
    <HeaderBar fixed className="z-10">
      <HeaderBarLeftAction
        icon={<CloseIcon className="stroke-current text-default" />}
        onClick={() => historyUtils.backToApp(router.back)}
      />
    </HeaderBar>
  )
}

MateriTextPage.layoutOpts = {
  hasHeader: true,
  className: 'text-default bg-gray-5',
  header: PageHeader,
  enableDesktopLayout: true,
}

export default MateriTextPage
